import { PresentationService } from '@prezi/presentation-service-client';
export let SchemaVersion = function (SchemaVersion) {
  SchemaVersion["CORE"] = "0";
  SchemaVersion["TIMELINE"] = "1";
  SchemaVersion["PITCH"] = "2";
  SchemaVersion["AIR_PITCH"] = "airp1";
  SchemaVersion["AIR_LITE"] = "airl1";
  SchemaVersion["AIR_VIDEO_PITCH"] = "airv1p1";
  SchemaVersion["AIR_VIDEO_LITE"] = "airv1l1";
  SchemaVersion["INFOGRAM"] = "ig1";
  return SchemaVersion;
}({});
export const getDocumentDetails = oid => {
  return PresentationService.getPresentationItem({
    oid,
    includeUserPermissions: true
  });
};
export const updateDocumentDetails = async (oid, prezi, tags = []) => {
  if (tags.length) {
    await PresentationService.updatePresentationItemTag({
      oid,
      tags: {
        tags
      }
    });
  }
  return PresentationService.updatePresentationItem({
    oid,
    prezi
  });
};
export const getUnifiedPrivacyAndPermissions = oid => PresentationService.getPresentationItemUnifiedPrivacy({
  oid,
  excludePermissions: false
});
export const setDocumentPublished = (oid, isPublished) => PresentationService.updatePresentationItemUnifiedPrivacy({
  oid,
  unifiedPermission: {
    published: isPublished
  }
});
export const setDocumentReusable = (oid, isReusable) => PresentationService.updatePresentationItemUnifiedPrivacy({
  oid,
  unifiedPermission: {
    reusable: isReusable
  }
});
export const setDocumentUnifiedPrivacy = (oid, unifiedPrivacy) => PresentationService.updatePresentationItemUnifiedPrivacy({
  oid,
  unifiedPermission: {
    unified_privacy: unifiedPrivacy
  }
});